import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

// Your Firebase configuration
// Replace these with your actual Firebase project credentials
// const firebaseConfig = {
//   apiKey: "your-api-key-here",
//   authDomain: "your-project-id.firebaseapp.com",
//   projectId: "your-project-id",
//   storageBucket: "your-project-id.appspot.com",
//   messagingSenderId: "your-sender-id",
//   appId: "your-app-id"
// };

const firebaseConfig = {
    apiKey: "AIzaSyDjOmXj0NpTFwrIvgm8hYOJuD8nAPE0AF8",
    authDomain: "replinq-ae50b.firebaseapp.com",
    projectId: "replinq-ae50b",
    storageBucket: "replinq-ae50b.firebasestorage.app",
    messagingSenderId: "684431679350",
    appId: "1:684431679350:web:5c3bac0e0b4e8d3f5c2457",
    measurementId: "G-LMQMWHKBG7"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Google Auth Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export default app; 